import * as React from "react";
import { useDispatch, useSelector } from "@teamprevent/admin-redux";

import { Button, Grid, Table, InputOnChangeData, Input } from "semantic-ui-react";
import { Authorize } from "reauthorize";

import { TASK_TYPE_OPTIONS } from "../model";
import { taskCodesSelector, SelectorState } from "../selectors";
import { ADMIN_ROLES } from "../../../auth";

import { loadTaskCodes } from "../actions";

import { Link, replace } from "redux-little-router";

export const All = () => {
    const [name, setName] = React.useState("");
    const path = useSelector((state: SelectorState) => state.router.pathname);
    const taskCodes = useSelector((state: SelectorState) => taskCodesSelector(state));
    const dispatch = useDispatch();
    const onFilterValueChange = React.useCallback((_: any, { value }: InputOnChangeData) => {
        setName(value);
        dispatch(replace("?name=" + `${value}`));
    }, [dispatch]);

    React.useEffect(() => {
        dispatch(loadTaskCodes());
    }, [dispatch]);

    return (
        <Grid container className="nomargintop">
            <Grid.Row>
                <Grid.Column width={14}>
                    <h1>General Tasks</h1>
                </Grid.Column>
                <Grid.Column width={2} textAlign="right">
                    <Authorize authorize={[ADMIN_ROLES.SYSTEM_ADMIN.name]}>
                        <Button icon="add" content="Create" as={Link} href={`${path}/create`} />
                    </Authorize>
                </Grid.Column>
            </Grid.Row>
            <Grid.Row>
                <Grid.Column width={16}>
                    <Table>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell>Name</Table.HeaderCell>
                                <Table.HeaderCell>Task Type</Table.HeaderCell>
                            </Table.Row>
                            <Table.Row>

                                <Table.HeaderCell>
                                    <Input
                                        value={name}
                                        onChange={onFilterValueChange}
                                        icon="search"
                                        placeholder="Search..."
                                        size="mini"
                                    />
                                </Table.HeaderCell>

                                <Table.HeaderCell />

                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {taskCodes?.sort((a, b) => a.name.localeCompare(b.name)).map(taskCode => (
                                <Table.Row key={taskCode.id}>
                                    <Table.Cell>
                                        <Link href={`${path}/${taskCode.id}`}>
                                            {taskCode.name}
                                        </Link>
                                    </Table.Cell>

                                    <Table.Cell>
                                        {TASK_TYPE_OPTIONS.find(t => t.value === taskCode.taskType)?.text}
                                    </Table.Cell>

                                </Table.Row>
                            ))}
                        </Table.Body>
                    </Table>
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};
